import * as React from 'react';
import { Button } from 'react-bootstrap';

import { IControlError, IControlSchemaBase } from '../../../core/Controls';
import { Dictionary } from '../../../types/Dictionary';

import { IDispatcher } from '../../helpers/Dispatcher';
import { Guid } from '../../helpers/Utils';

import MultipleFiles, { IFileSchema } from '../MultipleFiles';

import Table from './Table';
import { ControlDynamic, Field } from './types';

const totalPrice = (values: Array<any>, propName: string) => {
  const total: number = values.reduce((s, v) => s + parseFloat(v[propName]), 0);
  return total.toFixed(2);
};

interface Props {
  id: string;
  values: Array<any>;
  fields: Array<Field>;
  closed: boolean;
  elements: Array<ControlDynamic>;
  template: Array<IControlSchemaBase>;
  api: any;
  dispatcher: IDispatcher;
  controlValues: Array<any>;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>;
  allVisited: boolean;
  total: string;
  disabled?: boolean;
  onChange: (
    id: string,
    values: Array<any>,
    total: string,
    refresh: boolean,
  ) => void;
  onUpdate: (
    id: string,
    values: Array<any>,
    total: string,
    refresh: boolean,
  ) => void;
  onRemove: (id: string) => void;
  onCloused: (id: string) => void;
}

class PanelItem extends React.PureComponent<Props, object> {
  onChange = (values) =>
    this.props.onChange(
      this.props.id,
      values,
      totalPrice(values, 'price'),
      false,
    );

  onUpdate = (values) =>
    this.props.onUpdate(
      this.props.id,
      values,
      totalPrice(values, 'price'),
      true,
    );

  onClick = () => this.props.onRemove(this.props.id);

  onClose = () => this.props.onCloused(this.props.id);

  render() {
    const { api, dispatcher } = this.props;
    const result: Array<any> = [];
    for (const mapCtrl of this.props.elements) {
      const schema = this.props.template.find((t) => t.id === mapCtrl.id);
      if (schema) {
        const el = this.props.controlValues.find(
          (t) => t.controlid === mapCtrl.name,
        );
        result.push({
          ...schema,
          id: mapCtrl.name,
          value: el ? el.value : undefined,
        });
      }
    }
    return (
      <div style={{ marginBottom: '10px' }}>
        <Table
          disabled={this.props.closed}
          fields={this.props.fields}
          values={this.props.values}
          onChange={this.onChange}
          onUpdate={this.onUpdate}
        />
        <div style={{ marginTop: '10px' }}>
          {result.map((t) => (
            <MultipleFiles
              key={Guid.newGuid()}
              schema={t as IFileSchema}
              api={api}
              dispatcher={dispatcher}
              error={this.props.errors[t.id]}
            />
          ))}
        </div>
        <div>
          <div className="text-right" style={{ marginTop: '10px' }}>
            {/*// @ts-ignore*/}
            <Button
              bsStyle="success"
              onClick={this.onClose}
              disabled={this.props.values.length === 0 || this.props.closed}
            >
              Завершить работу с блоком
            </Button>
            {/*// @ts-ignore*/}
            <Button
              bsStyle="danger"
              disabled={this.props.disabled}
              onClick={this.onClick}
            >
              Удалить
            </Button>
          </div>
        </div>
        <div className="line" />
      </div>
    );
  }
}

export default PanelItem;
